import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import { generateId, isEmptyArray } from '../../common/util.services';
import { PAGE_SIZE } from '../../common/constants';
import { getProcess } from '../production.services';
import IButton from '../../../components/button/i-button.component';

const SelectWorkflow = (props: any) => {

  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [workflow, setWorkflow] = useState(rows);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const columns: GridColDef[] = [
    { field: 'processCode', headerName: 'Code', filterable: false, sortable: false, width: 100 },
    { field: 'process', headerName: 'Process', filterable: false, sortable: false, width: 300 },
    { field: 'remarks', headerName: 'Remarks', filterable: false, sortable: false, width: 300 },
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      getProcess(page, 100, appContext,
        (response: any) => {
          setWorkflow(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoading(false);
        });
    }
  }, [page, pageSize]);

  const onRowSelection = () => {
    if(selectedRows.length < 1) {
      appContext.setDialogMessage('Select a row.');
    }
    else if (props.onRowSelection) {
      selectedRows[0].id = generateId();
      props.onRowSelection(selectedRows);
    }
  }
  
  const onRowSelectionModelChange = (ids: any) => {
    const selectedIds = new Set(ids);
    const selectedRowData = workflow.filter((row) =>
      selectedIds.has(row.rowId)
    );
    setSelectedRows(selectedRowData);
  }

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  return <div className='work-flow'>
    <IGridComponent title='' showAddBtn={false} rows={workflow} columns={columns} maxHeight={"65vh"}
      getRowId={(row: any) => row.rowId} disableMultipleRowSelection={true} loading={loading}
      paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
      checkboxSelection={true} disableRowSelectionOnClick={true} rowSelectionModelChange={onRowSelectionModelChange} />
    <div className='btn-panel'>
      <IButton className='select-btn' label={'Select'} onActionEvent={onRowSelection}></IButton>
    </div>
  </div>
}

export default SelectWorkflow;